import Form from 'react-bootstrap/Form';
import { useTranslation } from 'react-i18next';
import { PatternFormat } from 'react-number-format';

function DateOfBirthForm({ consumer, formErrors, handleChange, renderError }) {
  const { t } = useTranslation();

  return (
    <Form.Group className="mb-3">
      <PatternFormat
        name="dateOfBirth"
        id="dateOfBirth"
        format="##/##/####"
        mask="_"
        className={formErrors && formErrors.dateOfBirth ? 'bo-input bo-input-error' : 'bo-input'}
        placeholder={t('pages.signup_details_second.date_of_birth_form.date_placeholder')}
        customInput={Form.Control}
        value={consumer.dateOfBirth ? consumer.dateOfBirth : ''}
        onChange={e => handleChange(e)}
      />
      {'dateOfBirth' in formErrors ? renderError(formErrors.dateOfBirth) : ''}
    </Form.Group>
  );
}

export default DateOfBirthForm;
